import NavigationBar from "components/shared/NavigationBar";
import { createContext, useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";

export const PageContext = createContext({});

function Page({
  className = "",
  childrenClassName = "flex-1 flex flex-col overflow-auto relative",
  leftButtons,
  rightButtons,
  backTo,
  title,
  subtitle = null,
  prompt,
  staticHeader = true,
  children,
  testing,
  testingMessage = "We are testing this page. If you have any feedback, please contact us.",
  ...rest
}) {
  const [searchParams] = useSearchParams();

  const contentRef = useRef();
  const [contentHeight, setContentHeight] = useState(0);

  useEffect(() => {
    if (contentRef.current) setContentHeight(contentRef.current.clientHeight);
  }, []);

  // build search params for url from state object

  let params = {};
  searchParams.forEach((value, key) => {
    params[key] = value;
  });
  const currentSearchString = new URLSearchParams(params).toString();
  const shouldAppendCurrentSearch =
    Boolean(currentSearchString) &&
    typeof backTo === "string" &&
    !backTo.includes("?");
  const resolvedBackTo = shouldAppendCurrentSearch
    ? `${backTo}?${currentSearchString}`
    : backTo;

  return (
    <PageContext.Provider value={{ contentHeight, setContentHeight }}>
      <div
        id="page"
        className={`flex flex-col flex-1 min-h-screen ${className}`}
        {...rest}
      >
        <NavigationBar
          leftButtons={leftButtons}
          rightButtons={rightButtons}
          backTo={resolvedBackTo}
          title={title}
          subtitle={subtitle}
          prompt={prompt}
          testing={testing}
          testingMessage={testingMessage}
        />

        <div className={childrenClassName} ref={contentRef}>
          {children}
        </div>
      </div>
    </PageContext.Provider>
  );
}

export default Page;
